import { ApiService } from './api.service';
import { SchoolSetting } from '@/models/school-setting';

class SchoolSettingService extends ApiService {
  constructor() {
    super();
  }

  fetch(): Promise<SchoolSetting> {
    return this.get(SchoolSetting, 'schoolSetting', {});
  }

  update(val: SchoolSetting): Promise<SchoolSetting> {
    return this.put(SchoolSetting, 'schoolSetting', val);
  }
}

export const schoolSettingService = new SchoolSettingService();
